import { useState } from "react";
import { signIn, useSession } from "next-auth/react";
import sectionStyles from "/components/Sections/Section.module.css";
import paneStyles from "/components/Panes/InfoPane.module.css";
import styles from "./ContributionForm.module.css";
export default function ExerciseCreator() {
  const { data: session, status } = useSession();
  const [form, setForm] = useState({
    title: "",
    summary: "",
    instructions: "",
    difficulty: 3,
    estimatedMinutes: 15,
  });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    const response = await fetch("/api/exercises/propose", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });
    const result = await response.json();
    if (!response.ok) return setError(result.error);
    setMessage(result.message);
    setForm({ ...form, title: "", summary: "", instructions: "" });
  };
  if (status === "loading") return null;
  if (!session?.user)
    return (
      <section className={sectionStyles.section}>
        <div className={paneStyles.infoPane}>
          <h1>Create an Exercise</h1>
          <p>Sign in to submit a learning exercise for review.</p>
          <button
            onClick={() =>
              signIn(undefined, { callbackUrl: "/ExerciseCreator" })
            }
          >
            Sign In
          </button>
        </div>
      </section>
    );
  return (
    <section className={sectionStyles.section}>
      <div className={styles.formPanel}>
        <h1>Create an Exercise</h1>
        <p>
          Describe a focused practice that another dancer can follow. Your
          proposal will be reviewed before publication.
        </p>
        <form onSubmit={submit}>
          <label>
            Title
            <input
              required
              maxLength="180"
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
            />
          </label>
          <label>
            Summary
            <textarea
              required
              value={form.summary}
              onChange={(e) => setForm({ ...form, summary: e.target.value })}
            />
          </label>
          <label>
            Instructions
            <textarea
              required
              value={form.instructions}
              onChange={(e) =>
                setForm({ ...form, instructions: e.target.value })
              }
              placeholder="Explain the goal, steps, constraints, and progression."
            />
          </label>
          <label>
            Difficulty (1–5)
            <input
              type="number"
              min="1"
              max="5"
              value={form.difficulty}
              onChange={(e) =>
                setForm({ ...form, difficulty: Number(e.target.value) })
              }
            />
          </label>
          <label>
            Estimated minutes
            <input
              type="number"
              min="1"
              value={form.estimatedMinutes}
              onChange={(e) =>
                setForm({ ...form, estimatedMinutes: Number(e.target.value) })
              }
            />
          </label>
          <button>Submit Exercise for Review</button>
          {message && <p className={styles.success}>{message}</p>}
          {error && <p className={styles.error}>{error}</p>}
        </form>
      </div>
    </section>
  );
}
